import { PackagesView } from "components/PackagesView/PackagesView";
import {
  filteredPackagesState,
  orderedPackagesAtom,
  packagesSearchFilterValueState,
  selectedCompanyState,
  selectedCountryState,
} from "store/UICompanyPage";

export function CompanyPackagesPage() {
  return (
    <>
      <PackagesView
        orderedPackagesAtom={orderedPackagesAtom}
        filteredPackageAtom={filteredPackagesState}
        searchFilterAtom={packagesSearchFilterValueState}
        selectedCompanyAtom={selectedCompanyState}
        selectedCountryAtom={selectedCountryState}
      />
    </>
  );
}
